import React from 'react';
import { useToggle } from 'react-use';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';


export default function SimpleModal(props) {
  const { title, children, onClickClose, ...extraProps } = props;
  return (
    <Modal toggle={onClickClose} {...extraProps}>
      <ModalHeader>
        {title}
      </ModalHeader>
      <ModalBody>
        {children}
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
}
